import { render, staticRenderFns } from "./BulkPricing.vue?vue&type=template&id=c9b29c42&scoped=true&"
import script from "./BulkPricing.vue?vue&type=script&lang=js&"
export * from "./BulkPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b29c42",
  null
  
)

export default component.exports